
(function(){
'use strict';

/* ── Helpers ── */
function eur(n){return n.toLocaleString('de-DE',{style:'currency',currency:'EUR',minimumFractionDigits:2});}
function h(s){return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
function imgTag(src,alt,cls){
  if(!src) return '<div class="zkv2-prod-card-img" style="background:#e8f0f5"></div>';
  return '<div class="zkv2-prod-card-img"><img src="'+h(src)+'" alt="'+h(alt||'Zaunprodukt')+'" loading="lazy"'+(cls?' class="'+cls+'"':'')+' onerror="this.parentNode.style.background=\'#e8f0f5\';this.remove()"></div>';
}
function cdnImg(src,w){
  if(!src) return '';
  return src.replace(/(_\d+x\d*\.|_\d*x\d+\.)/,'.').replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i,'_'+w+'x.$1$2');
}
/* HTML-sicheres JS-String-Literal für onclick-Attribute */
function js(s){
  if(s==null) return 'null';
  if(typeof s==='number'||typeof s==='boolean') return String(s);
  return "'"+String(s).replace(/\\/g,'\\\\').replace(/'/g,"\\'")+"'";
}

/* ── State ── */
var S = {
  step: 1,
  model: null,    // '6/5/6 Standard' or '8/6/8 Premium'
  farbe: null,    // e.g. 'anthrazitgrau'
  hoehe: null,    // e.g. '830 mm'
  laenge: 20,
  befestigung: null,
  fussplatte: null, // {id, title, price}
  sichtschutz: false,
  ss: null,         // {id, title, price, qty}
  pfosten: null,    // 'klemme' or 'abd'
  eckpfosten: 0,
  torTyp: 'einzel',
  torModel: null,   // handle des gewählten Tormodells
  torItems: {},     // {vid: qty}
  montage: null     // 'selbst' or 'profi'
};

/* ── Step flow ── */
function getFlow(){
  var f=[1,2,3,4,5];
  if(S.befestigung==='duebel') f.push(6);
  f.push(7);
  if(S.sichtschutz) f.push(8);
  f.push(9,10,11);
  return f;
}

function currentIdx(){return getFlow().indexOf(S.step);}
function totalSteps(){return getFlow().length;}

/* ── Variant finder ── */
function findVar(variants,terms,onlyAvail){
  outer: for(var i=0;i<variants.length;i++){
    var v=variants[i];
    if(onlyAvail&&!v.available) continue;
    var joined=[(v.o1||''),(v.o2||''),(v.o3||'')].join(' ').toLowerCase();
    for(var t=0;t<terms.length;t++){
      if(terms[t] && joined.indexOf(String(terms[t]).toLowerCase())===-1) continue outer;
    }
    return v;
  }
  return null;
}
/* Kurzschlüssel für Farbabgleich (Pfosten/Eckpfosten/Fußplatten haben andere Bezeichnungen als Matten) */
function farbK(s){ return (s||'').slice(0,6); }

/* ── Color definitions ── */
var COLORS = {
  'anthrazitgrau':  {css:'#3d4147', label:'Anthrazitgrau',  sub:'RAL 7016'},
  'moosgrün':       {css:'#3a5a3a', label:'Moosgrün',        sub:'RAL 6005'},
  'verzinkt':       {css:'linear-gradient(135deg,#c5c9ce,#8d9099)', label:'Verzinkt', sub:'Feuerverzinkt'},
  'hellgrau':       {css:'#b8babe', label:'Hellgrau',         sub:''},
  'steingrau':      {css:'#7c7f83', label:'Steingrau',        sub:''},
  'fenstergrau':    {css:'#8a8e93', label:'Fenstergrau',      sub:''},
  'weiß':           {css:'#f0f0ee', label:'Weiß',             sub:''},
  'dunkelbraun':    {css:'#4a2c17', label:'Dunkelbraun',      sub:''},
  'braun':          {css:'#8b5a2b', label:'Braun',            sub:''},
  'tannengrün':     {css:'#1a472a', label:'Tannengrün',       sub:''},
  'grün':           {css:'#4a7a4a', label:'Grün',             sub:''},
  'transparent':    {css:'repeating-linear-gradient(45deg,#ccc 0,#ccc 2px,#fff 0,#fff 50%)', label:'Transparent', sub:''},
  'blau':           {css:'#4a6fa5', label:'Blau',             sub:''},
  'gelb':           {css:'#d4b700', label:'Gelb',             sub:''}
};
function colorDef(key){
  if(!key) return {css:'#aaa',label:'',sub:''};
  var k=key.toLowerCase();
  if(COLORS[k]) return COLORS[k];
  for(var c in COLORS){ if(k.indexOf(c.replace('ü','u'))>-1) return COLORS[c]; }
  return {css:'#aaa',label:key,sub:''};
}

/* ── Progress bar (no-op in single-page mode) ── */
function renderProgress(){}

/* ── Summary sidebar ── */
function sumItem(img,name,detail,desc,val){
  var imgHtml=img
    ?'<img class="zkv2-si-img" src="'+h(cdnImg(img,80))+'" alt="'+h(name||'Ausgewähltes Zaunprodukt')+'" loading="lazy" onerror="this.style.display=\'none\'">'
    :'<div class="zkv2-si-img"></div>';
  return '<div class="zkv2-si">'
    +imgHtml
    +'<div class="zkv2-si-body">'
    +'<div class="zkv2-si-name">'+h(name)+'</div>'
    +'<div class="zkv2-si-detail">'+detail+'</div>'
    +'<div class="zkv2-si-desc">'+h(desc)+'</div>'
    +'</div>'
    +'<div class="zkv2-si-price">'+val+'</div>'
    +'</div>';
}

function updateSummary(){
  // Re-enable cart button after a successful add (user changed the config)
  var _cb=document.getElementById('zkv2-cart-btn');
  if(_cb&&_cb.dataset.added){
    _cb.dataset.added='';
    _cb.disabled=false;
    _cb.innerHTML='<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> In den Warenkorb';
  }

  var html='';
  // gesamtPreis = Summe der echten Varianten-Preise (taxes_included=True → bereits Brutto)
  var gesamtPreis=0;
  var panels=S.laenge>0?Math.ceil(S.laenge/2.5):0;

  var torCount=0;
  Object.keys(S.torItems).forEach(function(k){torCount+=S.torItems[k]||0;});
  var regPf=Math.max(0,panels+1-torCount);
  var totalPf=regPf+S.eckpfosten;

  // Matte
  if(S.model&&S.farbe&&S.hoehe&&panels>0){
    var mv=findVar(ZK.matte.variants,[S.model,S.farbe,S.hoehe],true)||findVar(ZK.matte.variants,[S.model,S.farbe,S.hoehe]);
    if(mv){
      var mprice=mv.price*panels;
      gesamtPreis+=mprice;
      var mimg=modelImg(S.model);
      html+=sumItem(mimg,'Doppelstabmattenzaun',
        h(S.model)+' · '+h(S.farbe)+' · '+h(S.hoehe)+' · '+panels+' Matten · '+totalPf+' Pfosten',
        'Pulverbeschichtet · feuerverzinkt · '+S.laenge+' m Zaun',
        eur(mprice));
    }
  }

  // Pfosten
  if(S.pfosten&&S.hoehe&&S.farbe&&regPf>0){
    var pfProd=S.pfosten==='klemme'?ZK.klemme:ZK.abd;
    var hM=(parseFloat(S.hoehe)/1000).toFixed(2).replace('.',',');
    var pfv=findVar(pfProd.variants,[hM,farbK(S.farbe)],true)||findVar(pfProd.variants,[S.hoehe,farbK(S.farbe)],true)||findVar(pfProd.variants,[hM,farbK(S.farbe)])||findVar(pfProd.variants,[S.hoehe,farbK(S.farbe)]);
    if(pfv){
      gesamtPreis+=pfv.price*regPf;
      html+=sumItem(pfProd.img,pfProd.title,
        h(S.farbe)+' · '+h(S.hoehe)+' · '+regPf+' Stück',
        S.pfosten==='klemme'?'System S · Klemmhalter · Schnellmontage':'System P · Abdeckleiste · hochwertiger Look',
        eur(pfv.price*regPf));
    }
  }

  // Eckpfosten
  if(S.eckpfosten>0&&S.pfosten&&S.hoehe&&S.farbe){
    var eckProd=S.pfosten==='klemme'?ZK.eck_k:ZK.eck_a;
    var hM2=(parseFloat(S.hoehe)/1000).toFixed(2).replace('.',',');
    var eckv=findVar(eckProd.variants,[hM2,farbK(S.farbe)],true)||findVar(eckProd.variants,[S.hoehe,farbK(S.farbe)],true)||findVar(eckProd.variants,[hM2,farbK(S.farbe)])||findVar(eckProd.variants,[S.hoehe,farbK(S.farbe)]);
    if(eckv){
      gesamtPreis+=eckv.price*S.eckpfosten;
      html+=sumItem(eckProd.img,eckProd.title,
        h(S.farbe)+' · '+h(S.hoehe)+' · '+S.eckpfosten+' Stück',
        'Für Ecken und Richtungswechsel im Zaun',
        eur(eckv.price*S.eckpfosten));
    }
  }

  // Fußplatten
  if(S.befestigung==='duebel'&&S.fussplatte){
    var fpQty=regPf+S.eckpfosten;
    if(fpQty>0){
      var fpImg='';
      ZK.fp.forEach(function(fp){if(fp.handle===S.fussplatte.handle) fpImg=fp.img;});
      gesamtPreis+=S.fussplatte.price*fpQty;
      html+=sumItem(fpImg,S.fussplatte.title,
        fpQty+' Stück · Befestigung auf Mauer/Boden',
        'Wandmontage · bohren und dübeln',
        eur(S.fussplatte.price*fpQty));
    }
  }

  // Sichtschutz
  if(S.sichtschutz&&S.ss){
    var ssCalc=calcSSQty();
    if(ssCalc.qty>0){
      var ssImg='';
      ZK.ss.forEach(function(s){if(s&&s.handle===S.ss.handle) ssImg=s.img;});
      gesamtPreis+=S.ss.price*ssCalc.qty;
      html+=sumItem(ssImg,S.ss.title,
        h(S.ss.colorVal||'')+' · '+ssCalc.qty+' '+ssCalc.unit,
        'Einflechten in Doppelstabmatte · Sicht- und Windschutz',
        eur(S.ss.price*ssCalc.qty));
    }
  }

  // Tore
  Object.keys(S.torItems).forEach(function(vid){
    var qty=S.torItems[vid]||0;
    if(!qty) return;
    var tor=findTor(vid);
    if(!tor) return;
    gesamtPreis+=tor.price*qty;
    var torImg='',breiteInfo='';
    ZK.einzeltore.concat(ZK.doppeltore).forEach(function(t){
      if(!t) return;
      t.variants.forEach(function(v){
        if(v.id==vid){
          torImg=t.img;
          var ht=(S.hoehe||'').toLowerCase();
          [v.o1,v.o2,v.o3].forEach(function(f){if(f&&f.toLowerCase()!==ht&&f.match(/\d{3,4}\s*mm/)) breiteInfo=f;});
        }
      });
    });
    html+=sumItem(torImg,tor.label.split(' · ')[0],
      (breiteInfo?'Breite '+h(breiteInfo)+' · ':'')+h(S.farbe||'')+' · '+h(S.hoehe||'')+' · '+qty+' Stück',
      'Inkl. Torpfosten und Beschläge',
      eur(tor.price*qty));
  });


  var sumEl=document.getElementById('zkv2-sum-items');
  if(sumEl) sumEl.innerHTML=html||'<div class="zkv2-si-empty">Noch keine Auswahl</div>';
  var abholPreis=Math.round(gesamtPreis*0.97*100)/100;
  var netEl=document.getElementById('zkv2-netto');
  var bruEl=document.getElementById('zkv2-brutto');
  // Abholpreis = gesamtPreis * 0.97 (3% Abholrabatt)
  if(netEl) netEl.textContent=abholPreis>0?eur(abholPreis/1.19):'–';
  if(bruEl) bruEl.textContent=abholPreis>0?eur(abholPreis):'–';
  var strikeWrap=document.getElementById('zkv2-strike-wrap');
  var strikeEl=document.getElementById('zkv2-strike');
  if(gesamtPreis>0){
    if(strikeEl) strikeEl.textContent=eur(gesamtPreis);
    if(strikeWrap) strikeWrap.style.display='';
  } else {
    if(strikeWrap) strikeWrap.style.display='none';
  }
}

function findTor(vid){
  var all=ZK.einzeltore.concat(ZK.doppeltore);
  for(var i=0;i<all.length;i++){
    for(var j=0;j<all[i].variants.length;j++){
      if(all[i].variants[j].id==vid){
        var v=all[i].variants[j];
        var label=all[i].title+(v.o3?' · '+v.o3:'');
        return {price:v.price,label:label};
      }
    }
  }
  return null;
}

/* ────────────────────────────────
   STEP RENDERERS
   ──────────────────────────────── */

function modelImg(val){
  var v=(val||'').replace(/[^0-9\/]/g,'');
  return (v.indexOf('8')===0||v.indexOf('8/6/8')>-1)?ZK.matte.img_868:ZK.matte.img_656;
}
function modelSub(val){
  var v=(val||'').toLowerCase();
  if(v.indexOf('8/6/8')>-1||v.indexOf('868')>-1) return 'Ø 8/6/8 mm · Stärkerer Draht';
  if(v.indexOf('6/5/6')>-1||v.indexOf('656')>-1) return 'Ø 6/5/6 mm · Standarddraht';
  return '';
}

function renderStep1(){
  /* Modellwerte direkt aus den echten Varianten lesen */
  var seen={}, modelVals=[];
  ZK.matte.variants.forEach(function(v){if(!seen[v.o1]){seen[v.o1]=true;modelVals.push(v.o1);}});

  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 1</div>'
    +'<div class="zkv2-step-title">Zaunmodell wählen</div>'
    +'<div class="zkv2-step-desc">Wählen Sie den Drahtdurchmesser für Ihre Doppelstabmatte</div></div>'
    +'<div class="zkv2-grid zkv2-grid-2">';
  modelVals.forEach(function(val){
    var sel=S.model===val?'selected':'';
    html+='<div class="zkv2-prod-card '+sel+'" onclick="ZKW.pickModel('+js(val)+')">'
      +imgTag(cdnImg(modelImg(val),600),val)
      +'<div class="zkv2-prod-card-body"><div class="zkv2-prod-card-title">'+h(val)+'</div>'
      +'<div class="zkv2-prod-card-sub">'+h(modelSub(val))+'</div></div>'
      +'<div class="zkv2-check"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg></div>'
      +'</div>';
  });
  html+='</div><div class="zkv2-note">Eine Zaunmatte ist immer <strong>2,50 m breit</strong>. Für 10 m Zaun benötigen Sie 4 Matten + 5 Pfosten.</div>';
  return html;
}

function renderStep2(){
  // Colors from matte variants filtered by model
  var seen={}, colors=[];
  ZK.matte.variants.forEach(function(v){
    if(!S.model||v.o1===S.model){
      if(!seen[v.o2]){seen[v.o2]=true;colors.push(v.o2);}
    }
  });
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 2</div>'
    +'<div class="zkv2-step-title">Farbe / Oberfläche</div>'
    +'<div class="zkv2-step-desc">Gilt für Zaunmatten und Pfosten</div></div>'
    +'<div class="zkv2-swatches">';
  colors.forEach(function(c){
    var def=colorDef(c);
    var sel=S.farbe===c?'selected':'';
    html+='<div class="zkv2-swatch '+sel+'" onclick="ZKW.pickFarbe('+js(c)+')">'
      +'<div class="zkv2-swatch-dot" style="background:'+def.css+'"></div>'
      +'<div><div class="zkv2-swatch-name">'+h(def.label)+'</div><div class="zkv2-swatch-ral">'+h(def.sub)+'</div></div>'
      +'</div>';
  });
  html+='</div>';
  return html;
}

function renderStep3(){
  // Heights from matte variants filtered by model+color
  var seen={}, heights=[];
  ZK.matte.variants.forEach(function(v){
    if((!S.model||v.o1===S.model)&&(!S.farbe||v.o2===S.farbe)){
      if(!seen[v.o3]){seen[v.o3]=true;heights.push({val:v.o3,price:v.price});}
    }
  });
  // Sort numerically
  heights.sort(function(a,b){return parseFloat(a.val)-parseFloat(b.val);});
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 3</div>'
    +'<div class="zkv2-step-title">Höhe wählen</div>'
    +'<div class="zkv2-step-desc">Gilt für Matten und Pfosten · Preis je Matte (2,50 m)</div></div>'
    +'<div class="zkv2-height-cards">';
  heights.forEach(function(ht){
    var sel=S.hoehe===ht.val?'selected':'';
    var mm=parseFloat(ht.val);
    var cm=Math.round(mm/10);
    html+='<div class="zkv2-h-card '+sel+'" onclick="ZKW.pickHoehe('+js(ht.val)+')">'
      +'<div class="zkv2-h-card-cm">'+cm+' cm</div>'
      +'<div class="zkv2-h-card-mm">'+ht.val+'</div>'
      +'<div class="zkv2-h-card-price">'+eur(ht.price)+'/Matte</div>'
      +'</div>';
  });
  html+='</div>';
  return html;
}

function renderStep4(){
  var panels=Math.ceil(S.laenge/2.5);
  var pfosten=panels+1;
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 4</div>'
    +'<div class="zkv2-step-title">Zaunlänge eingeben</div>'
    +'<div class="zkv2-step-desc">Gesamte Zaunlänge in Metern</div></div>'
    +'<div class="zkv2-length-wrap">'
    +'<div class="zkv2-length-display">'
    +'<input type="number" class="zkv2-length-num" id="zk-laenge-num" value="'+S.laenge+'" min="1" max="500" step="1" oninput="ZKW.setLaenge(this.value)">'
    +'<span class="zkv2-length-unit">Meter</span>'
    +'</div>'
    +'<input type="range" class="zkv2-slider" id="zk-laenge-slider" min="1" max="200" value="'+Math.min(S.laenge,200)+'" step="1" oninput="ZKW.setLaengeSlider(this.value)">'
    +'<div style="display:flex;justify-content:space-between;font-size:.72rem;color:#7a9aaa;margin-top:.25rem"><span>1 m</span><span>100 m</span><span>200 m</span></div>'
    +'<div class="zkv2-length-hint" id="zk-laenge-hint">'+panels+' Matten · '+pfosten+' Pfosten (ohne Tore)</div>'
    +'</div>';
  return html;
}

function renderStep5(){
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 5</div>'
    +'<div class="zkv2-step-title">Befestigungsart</div>'
    +'<div class="zkv2-step-desc">Wie werden die Pfosten befestigt?</div></div>'
    +'<div class="zkv2-bef-cards">'
    +'<div class="zkv2-bef-card '+(S.befestigung==='einbetonieren'?'selected':'')+'" onclick="ZKW.pickBef(\'einbetonieren\')">'
    +'<div class="zkv2-bef-icon">🏗️</div>'
    +'<div class="zkv2-bef-name">Einbetonieren</div>'
    +'<div class="zkv2-bef-sub">Pfosten werden in Boden einbetoniert<br>Keine Zusatzartikel nötig</div>'
    +'</div>'
    +'<div class="zkv2-bef-card '+(S.befestigung==='duebel'?'selected':'')+'" onclick="ZKW.pickBef(\'duebel\')">'
    +'<div class="zkv2-bef-icon">🔩</div>'
    +'<div class="zkv2-bef-name">Auf Mauer dübeln</div>'
    +'<div class="zkv2-bef-sub">Pfosten werden mit Fußplatten<br>auf Mauer oder Boden montiert</div>'
    +'</div>'
    +'</div>';
  return html;
}

function renderStep6(){
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 6</div>'
    +'<div class="zkv2-step-title">Fußplatten wählen</div>'
    +'<div class="zkv2-step-desc">Je Pfosten eine Fußplatte · '+calcPfosten()+' Pfosten insgesamt</div></div>';
  if(!ZK.fp||ZK.fp.length===0){
    html+='<div class="zkv2-note">Fußplatten werden individuell konfiguriert – bitte kontaktieren Sie uns.</div>';
    return html;
  }
  html+='<div class="zkv2-grid zkv2-grid-2">';
  ZK.fp.forEach(function(fp){
    // Find cheapest variant matching color
    var fpv=findVar(fp.variants,[farbK(S.farbe)],true)||findVar(fp.variants,[farbK(S.farbe)])||findVar(fp.variants,[]);
    var price=fpv?fpv.price:0;
    var sel=(S.fussplatte&&S.fussplatte.handle===fp.handle)?'selected':'';
    html+='<div class="zkv2-prod-card '+sel+'" onclick="ZKW.pickFussplatte('+js(fp.handle)+','+js(fpv&&fpv.id)+','+js(fp.title)+','+price+')">'
      +imgTag(cdnImg(fp.img,400),fp.title)
      +'<div class="zkv2-prod-card-body"><div class="zkv2-prod-card-title">'+h(fp.title)+'</div>'
      +(price>0?'<div class="zkv2-prod-card-price">'+eur(price)+' / Stück</div>':'')
      +'</div>'
      +'<div class="zkv2-check"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg></div>'
      +'</div>';
  });
  html+='</div>';
  return html;
}

function renderStep7(){
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 7</div>'
    +'<div class="zkv2-step-title">Sichtschutz hinzufügen?</div>'
    +'<div class="zkv2-step-desc">Optionaler Sichtschutz passend zur Doppelstabmatte</div></div>'
    +'<div class="zkv2-toggle-row">'
    +'<div class="zkv2-toggle-card '+(S.sichtschutz===false&&S.sichtschutz!==null?'selected':'')+'" onclick="ZKW.setSichtschutz(false)">✗ Nein, kein Sichtschutz</div>'
    +'<div class="zkv2-toggle-card '+(S.sichtschutz===true?'selected':'')+'" onclick="ZKW.setSichtschutz(true)">✓ Ja, Sichtschutz gewünscht</div>'
    +'</div>';
  if(S.sichtschutz){
    html+='<div class="zkv2-sub-h" style="margin-top:1.25rem">Sichtschutz auswählen</div>'
      +'<div class="zkv2-grid zkv2-grid-3">';
    ZK.ss.forEach(function(ss){
      if(!ss||!ss.variants) return;
      var ssv=ss.variants.find(function(v){return v.available;})||ss.variants[0];
      var price=ssv?ssv.price:0;
      var sel=(S.ss&&S.ss.handle===ss.handle)?'selected':'';
      html+='<div class="zkv2-prod-card '+sel+'" onclick="ZKW.pickSS('+js(ss.handle)+')">'
        +(ss.bestseller?'<div class="zkv2-badge-bs">Bestseller</div>':'')
        +imgTag(cdnImg(ss.img,400),ss.title)
        +'<div class="zkv2-prod-card-body"><div class="zkv2-prod-card-title">'+h(ss.title)+'</div>'
        +(price>0?'<div class="zkv2-prod-card-price">ab '+eur(price)+' / Rolle</div>':'')
        +'</div>'
        +'<div class="zkv2-check"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg></div>'
        +'</div>';
    });
    html+='</div>';
  }
  return html;
}

function renderStep8(){
  // Sichtschutzfarbe
  var ssProd=S.ss?ZK.ss.find(function(s){return s&&s.handle===S.ss.handle;}):null;
  var colors=[];
  if(ssProd){
    var seen={};
    ssProd.variants.forEach(function(v){if(!seen[v.o1]){seen[v.o1]=true;colors.push({val:v.o1,id:v.id,price:v.price});}});
  }
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 8</div>'
    +'<div class="zkv2-step-title">Sichtschutzfarbe wählen</div>'
    +'<div class="zkv2-step-desc">Farbe passend zur Zaunmatte</div></div>'
    +'<div class="zkv2-swatches">';
  colors.forEach(function(c){
    var def=colorDef(c.val);
    var sel=(S.ss&&S.ss.colorVal===c.val)?'selected':'';
    html+='<div class="zkv2-swatch '+sel+'" onclick="ZKW.pickSSFarbe('+js(c.val)+','+c.id+','+c.price+')">'
      +'<div class="zkv2-swatch-dot" style="background:'+def.css+'"></div>'
      +'<div><div class="zkv2-swatch-name">'+h(def.label||c.val)+'</div></div>'
      +'</div>';
  });
  if(colors.length===0) html+='<div class="zkv2-note">Bitte zuerst ein Sichtschutzprodukt auswählen.</div>';
  html+='</div>';
  return html;
}

function renderStep9(){
  var ssActive=S.sichtschutz;
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 9</div>'
    +'<div class="zkv2-step-title">Pfostenausführung</div>'
    +'<div class="zkv2-step-desc">System S = Klemmhalter · System P = Abdeckleiste</div></div>';
  if(ssActive){
    html+='<div class="zkv2-note" style="margin-bottom:1rem">ℹ️ Bei Sichtschutz ist <strong>Abdeckleiste (System P)</strong> erforderlich.</div>';
  }
  html+='<div class="zkv2-grid zkv2-grid-2">';
  // Klemmhalter
  var klImg=ZK.klemme.img;
  var klSel=!ssActive&&S.pfosten==='klemme'?'selected':'';
  var klDis=ssActive?'style="opacity:.4;pointer-events:none"':'';
  html+='<div class="zkv2-prod-card '+klSel+'" onclick="ZKW.pickPfosten(\'klemme\')" '+klDis+'>'
    +imgTag(cdnImg(klImg,400),ZK.klemme.title)
    +'<div class="zkv2-prod-card-body"><div class="zkv2-prod-card-title">'+h(ZK.klemme.title)+'</div>'
    +'<div class="zkv2-prod-card-sub">System S · Schnellmontage</div></div>'
    +'<div class="zkv2-check"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg></div>'
    +'</div>';
  // Abdeckleiste
  var abdImg=ZK.abd.img;
  var abdSel=S.pfosten==='abd'?'selected':'';
  html+='<div class="zkv2-prod-card '+abdSel+'" onclick="ZKW.pickPfosten(\'abd\')">'
    +imgTag(cdnImg(abdImg,400),ZK.abd.title)
    +'<div class="zkv2-prod-card-body"><div class="zkv2-prod-card-title">'+h(ZK.abd.title)+'</div>'
    +'<div class="zkv2-prod-card-sub">System P · Hochwertiger Look</div></div>'
    +'<div class="zkv2-check"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg></div>'
    +'</div>';
  html+='</div>';
  return html;
}

function renderStep10(){
  var eckProd=S.pfosten==='klemme'?ZK.eck_k:ZK.eck_a;
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 10</div>'
    +'<div class="zkv2-step-title">Eckpfosten</div>'
    +'<div class="zkv2-step-desc">Anzahl der Ecken in Ihrer Zaunanlage</div></div>'
    +'<div style="display:flex;gap:1.5rem;align-items:flex-start;flex-wrap:wrap">'
    +'<div>'
    +imgTag(cdnImg(eckProd.img,300),eckProd.title,'')
    +'</div>'
    +'<div>'
    +'<div class="zkv2-prod-card-title" style="margin-bottom:.5rem">'+h(eckProd.title)+'</div>'
    +'<div class="zkv2-stepper-wrap">'
    +'<div class="zkv2-stepper">'
    +'<button class="zkv2-step-btn" onclick="ZKW.changeEck(-1)" '+(S.eckpfosten<=0?'disabled':'')+'>−</button>'
    +'<div class="zkv2-step-val">'+S.eckpfosten+'</div>'
    +'<button class="zkv2-step-btn" onclick="ZKW.changeEck(1)" '+(S.eckpfosten>=8?'disabled':'')+'>+</button>'
    +'</div>'
    +'<div class="zkv2-stepper-label">Eckpfosten<br><span style="color:#1a5c7a;font-weight:600">Max. 8 Stück</span></div>'
    +'</div>'
    +'</div>'
    +'</div>';
  return html;
}

function renderStep11(){
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 11</div>'
    +'<div class="zkv2-step-title">Tore hinzufügen</div>'
    +'<div class="zkv2-step-desc">Optional · Tore haben eigene Pfosten, keine Berechnung zusätzlicher Pfosten</div></div>'
    +'<div class="zkv2-tor-type-tabs">'
    +'<div class="zkv2-tor-tab '+(S.torTyp==='einzel'?'active':'')+'" onclick="ZKW.setTorTyp(\'einzel\')">🚪 Einzeltor / Gartentür</div>'
    +'<div class="zkv2-tor-tab '+(S.torTyp==='doppel'?'active':'')+'" onclick="ZKW.setTorTyp(\'doppel\')">🏠 Doppelflügeltor</div>'
    +'</div>'
    +'<div class="zkv2-tor-section '+(S.torTyp==='einzel'?'active':'')+'" id="zk-tor-einzel">'
    +renderTorList(ZK.einzeltore)+'</div>'
    +'<div class="zkv2-tor-section '+(S.torTyp==='doppel'?'active':'')+'" id="zk-tor-doppel">'
    +renderTorList(ZK.doppeltore)+'</div>'
    +'<div class="zkv2-note">ℹ️ Tore beinhalten bereits Torpfosten. Für Tore werden keine zusätzlichen Zaunpfosten berechnet.</div>';
  return html;
}

function _breiteLabel(raw){
  var m=(raw||'').match(/^(\d+)\s*mm(.*)$/i);
  if(!m) return raw||'';
  var caM=(parseInt(m[1],10)/1000).toFixed(2).replace('.',',');
  var sfx=(m[2]||'').trim();
  return 'ca. '+caM+' m'+(sfx?' '+sfx:'');
}

var _TOR_H={'630':'0,83m','830':'0,83m','1030':'1,00m',
    '1230':'1,20m','1430':'1,40m','1630':'1,60m','1830':'1,80m','2030':'2,00m'};

function _torVarBestFit(tor,breiteRaw){
  var brOpt=tor.brOpt;
  var hoehe=(S.hoehe||'').toLowerCase();
  var farbe=(S.farbe||'').toLowerCase();
  var mm=Math.round(parseFloat(S.hoehe)||0);
  var hN=(_TOR_H[String(mm)]||'').toLowerCase();
  var all=tor.variants.filter(function(v){
    return !brOpt||!breiteRaw||v[brOpt]===breiteRaw;
  });
  function hMatch(j){
    if(!hoehe&&!hN) return true;
    if(hoehe&&j.indexOf(hoehe)>-1) return true;
    if(hN&&j.indexOf(hN)>-1) return true;
    return false;
  }
  function fMatch(j){
    if(!farbe) return true;
    if(j.indexOf(farbe)>-1) return true;
    var words=farbe.match(/\w{4,}/g)||[];
    return words.length>0&&words.every(function(w){return j.indexOf(w)>-1;});
  }
  var withHF=all.filter(function(v){
    var j=(v.o1+' '+v.o2+' '+v.o3).toLowerCase();
    return hMatch(j)&&fMatch(j);
  });
  if(withHF.length) return withHF[0];
  var withH=all.filter(function(v){
    return hMatch((v.o1+' '+v.o2+' '+v.o3).toLowerCase());
  });
  if(withH.length) return withH[0];
  return all[0]||null;
}

function torBreiten(tor){
  var brOpt=tor.brOpt||null;
  if(!brOpt){
    var fv=_torVarBestFit(tor,null);
    var lbl=tor.fixedLabel||'ca. 1,0 m (fest)';
    if(!fv) return [{id:null,breite:null,label:lbl,price:0,noMatch:true}];
    return [{id:fv.id,breite:null,label:lbl,price:fv.price}];
  }
  var seen={},list=[];
  tor.variants.forEach(function(v){
    var raw=v[brOpt]||'';
    if(!raw||seen[raw]) return;
    seen[raw]=true;
    var fv=_torVarBestFit(tor,raw);
    if(!fv){
      list.push({id:null,breite:raw,label:_breiteLabel(raw),price:0,noMatch:true});
    } else {
      list.push({id:fv.id,breite:raw,label:_breiteLabel(raw),price:fv.price});
    }
  });
  return list;
}

function renderTorList(tores){
  if(!tores||!tores.length) return '<div class="zkv2-note">Keine Tore verfügbar</div>';
  var html='';

  /* ── Schritt 1: Modell-Karten ── */
  html+='<div class="zkv2-grid zkv2-grid-4" style="margin-bottom:.75rem">';
  tores.forEach(function(tor){
    if(!tor||!tor.handle||!tor.title) return;
    var isSel=S.torModel===tor.handle;
    /* Günstigster passender Preis als "ab X" */
    var bl=torBreiten(tor);
    var minPrice=bl.length?bl.reduce(function(m,b){return b.price<m?b.price:m;},bl[0].price):0;
    html+='<div class="zkv2-prod-card'+(isSel?' selected':'')+'" onclick="ZKW.setTorModel('+js(tor.handle)+')" style="cursor:pointer">'
      +imgTag(cdnImg(tor.img,300),tor.title)
      +'<div class="zkv2-prod-card-body">'
      +'<div class="zkv2-prod-card-title">'+h(tor.title)+'</div>'
      +(minPrice>0?'<div class="zkv2-prod-card-price">ab '+eur(minPrice)+'</div>':'')
      +'</div>'
      +'<div class="zkv2-check"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg></div>'
      +'</div>';
  });
  html+='</div>';

  /* ── Schritt 2: Breiten für gewähltes Modell ── */
  tores.forEach(function(tor){
    if(!tor||S.torModel!==tor.handle) return;
    var bl=torBreiten(tor);
    html+='<div class="zkv2-breiten-expand">'
      +'<div class="zkv2-sub-h" style="margin-bottom:.75rem">Breite wählen</div>'
      +'<div class="zkv2-grid zkv2-grid-4">';
    bl.forEach(function(br){
      var qty=br.id?(S.torItems[br.id]||0):0;
      html+='<div class="zkv2-breite-card">'
        +imgTag(cdnImg(tor.img,300),tor.title)
        +'<div class="zkv2-breite-body">'
        +'<div class="zkv2-breite-val">'+(br.label||'Standard')+'</div>'
        +(br.price>0?'<div class="zkv2-breite-price">'+eur(br.price)+'</div>':'')
        +'<div class="zkv2-tor-qty">'
        +(br.noMatch
          ?'<div style="font-size:.75rem;color:#888;text-align:center;padding:.25rem 0">Nicht für '+h(S.hoehe||'diese Höhe')+' erhältlich</div>'
          :'<button class="zkv2-tor-qty-btn" onclick="ZKW.setTor('+br.id+',-1)">−</button>'
           +'<span class="zkv2-tor-qty-val" id="torqty-'+br.id+'">'+qty+'</span>'
           +'<button class="zkv2-tor-qty-btn" onclick="ZKW.setTor('+br.id+',1)">+</button>'
        )
        +'</div>'
        +'</div></div>';
    });
    html+='</div></div>';
  });
  return html;
}

function calcPfosten(){
  var panels=Math.ceil(S.laenge/2.5);
  var torCount=0;
  Object.keys(S.torItems).forEach(function(k){torCount+=S.torItems[k]||0;});
  return Math.max(0,panels+1-torCount)+S.eckpfosten;
}

function calcSSQty(){
  if(!S.ss||!S.hoehe) return {qty:0,unit:'Rollen'};
  var panels=Math.ceil(S.laenge/2.5);
  var reihen=Math.max(3,Math.round(parseFloat(S.hoehe)/200));
  var handle=(S.ss.handle||'').toLowerCase();
  var qty,unit;
  if(handle.indexOf('spenderrolle')>-1||handle.indexOf('10-streifen')>-1||handle.indexOf('streifen-premium')>-1){
    /* 10 Streifen pro Einheit/Rolle */
    qty=Math.ceil(panels*reihen/10);
    unit='Rollen';
  } else {
    /* Rolle à 26 m, Streifen je ~2,55 m */
    qty=Math.ceil(panels*reihen*2.55/26);
    unit='Rollen';
  }
  return {qty:qty,unit:unit};
}

function calcMontage(){
  var panels=Math.ceil(S.laenge/2.5);
  var einzelAnz=0,doppelAnz=0;
  Object.keys(S.torItems).forEach(function(vid){
    var qty=S.torItems[vid]||0;
    if(!qty) return;
    var isEinzel=ZK.einzeltore.some(function(t){return t&&t.variants.some(function(v){return v.id==vid;});});
    if(isEinzel) einzelAnz+=qty; else doppelAnz+=qty;
  });
  var torCount=einzelAnz+doppelAnz;
  var regPf=Math.max(0,panels+1-torCount);
  var normal=regPf*100+S.eckpfosten*100+einzelAnz*200+doppelAnz*400;
  return Math.max(1000,normal);
}

function renderStep12(){
  var montagePreis=calcMontage();
  var html='<div class="zkv2-step-header"><div class="zkv2-step-num">Schritt 12</div>'
    +'<div class="zkv2-step-title">Montage</div>'
    +'<div class="zkv2-step-desc">Möchten Sie den Zaun selbst montieren oder durch uns montieren lassen?</div></div>'
    +'<div class="zkv2-bef-cards">'
    +'<div class="zkv2-bef-card '+(S.montage==='selbst'?'selected':'')+'" onclick="ZKW.pickMontage(\'selbst\')">'
    +'<div class="zkv2-bef-icon">🔧</div>'
    +'<div class="zkv2-bef-name">Selbstmontage</div>'
    +'<div class="zkv2-bef-sub">Ich montiere den Zaun selbst<br>Anleitungen werden mitgeliefert</div>'
    +'</div>'
    +'<div class="zkv2-bef-card '+(S.montage==='profi'?'selected':'')+'" onclick="ZKW.pickMontage(\'profi\')">'
    +'<div class="zkv2-bef-icon">👷</div>'
    +'<div class="zkv2-bef-name">Profimontage</div>'
    +'<div class="zkv2-bef-sub">Montage durch unsere Fachleute · inkl. Einbetonieren<br>'
    +'<strong style="color:#1e7bb8">'+eur(montagePreis)+' Netto</strong></div>'
    +'</div>'
    +'</div>';
  return html;
}

/* ── Single-page render: alle Schritte auf einmal ── */
function render(){
  var area=document.getElementById('zkv2-all-steps');
  if(!area) return;
  try {
    var hasFP=ZK.fp&&ZK.fp.length>0;
    var html='';
    html+='<div class="zkv2-step-card">'+renderStep1()+'</div>';
    html+='<div class="zkv2-step-card">'+renderStep2()+'</div>';
    html+='<div class="zkv2-step-card">'+renderStep3()+'</div>';
    html+='<div class="zkv2-step-card">'+renderStep4()+'</div>';
    html+='<div class="zkv2-step-card">'+renderStep5()+'</div>';
    html+='<div class="zkv2-step-card" id="zk-fp-step" style="'+(S.befestigung==='duebel'&&hasFP?'':'display:none')+'">'+renderStep6()+'</div>';
    html+='<div class="zkv2-step-card">'+renderStep7()+'</div>';
    html+='<div class="zkv2-step-card" id="zk-ssf-step" style="'+(S.sichtschutz?'':'display:none')+'">'+renderStep8()+'</div>';
    html+='<div class="zkv2-step-card">'+renderStep9()+'</div>';
    html+='<div class="zkv2-step-card">'+renderStep10()+'</div>';
    html+='<div class="zkv2-step-card">'+renderStep11()+'</div>';
    area.innerHTML=html;
    // Schritt-Nummern fortlaufend an den SICHTBAREN Karten vergeben.
    // Ausgeblendete Schritte (z.B. Fußplatte/Sichtschutz) dürfen keine Lücke
    // in der Nummerierung erzeugen (Bug: sprang 5→7→9).
    var cards=area.querySelectorAll('.zkv2-step-card');
    var sNum=0;
    for(var ci=0;ci<cards.length;ci++){
      if(cards[ci].style.display==='none') continue;
      sNum++;
      var numEl=cards[ci].querySelector('.zkv2-step-num');
      if(numEl) numEl.textContent='Schritt '+sNum;
    }
  } catch(e){
    console.error('ZK render error:',e);
  }
  updateSummary();
}

/* ── Public API ── */
window.ZKW = {
  pickModel: function(val){
    S.model=val;
    // Farbe behalten wenn sie für das neue Modell verfügbar ist
    var farbeOk=!S.farbe||ZK.matte.variants.some(function(v){return v.o1===val&&v.o2===S.farbe;});
    if(!farbeOk){S.farbe=null;S.hoehe=null;}
    else{
      // Höhe behalten wenn Modell+Farbe+Höhe kombinierbar
      var hoeheOk=!S.hoehe||ZK.matte.variants.some(function(v){return v.o1===val&&v.o2===S.farbe&&v.o3===S.hoehe;});
      if(!hoeheOk) S.hoehe=null;
    }
    render();
  },
  pickFarbe: function(val){
    S.farbe=val;
    var hoeheOk=!S.hoehe||ZK.matte.variants.some(function(v){
      return (!S.model||v.o1===S.model)&&v.o2===val&&v.o3===S.hoehe;
    });
    if(!hoeheOk) S.hoehe=null;
    render();
  },
  pickHoehe: function(val){S.hoehe=val;render();},
  setLaenge: function(val){
    S.laenge=Math.max(1,Math.min(200,parseInt(val)||1));
    var sl=document.getElementById('zk-laenge-slider');
    if(sl) sl.value=Math.min(S.laenge,200);
    var panels=Math.ceil(S.laenge/2.5);
    var hint=document.getElementById('zk-laenge-hint');
    if(hint) hint.textContent=panels+' Matten · '+(panels+1)+' Pfosten (ohne Tore)';
    updateSummary();
  },
  setLaengeSlider: function(val){
    S.laenge=parseInt(val)||1;
    var num=document.getElementById('zk-laenge-num');
    if(num) num.value=S.laenge;
    var panels=Math.ceil(S.laenge/2.5);
    var hint=document.getElementById('zk-laenge-hint');
    if(hint) hint.textContent=panels+' Matten · '+(panels+1)+' Pfosten (ohne Tore)';
    updateSummary();
  },
  pickBef: function(val){
    S.befestigung=val;
    if(val==='einbetonieren') S.fussplatte=null;
    var fpEl=document.getElementById('zk-fp-step');
    if(fpEl) fpEl.style.display=(val==='duebel'&&ZK.fp&&ZK.fp.length>0)?'':'none';
    render();
  },
  pickFussplatte: function(handle,id,title,price){
    S.fussplatte={handle:handle,id:id,title:title,price:price};
    render();
  },
  setSichtschutz: function(val){
    S.sichtschutz=val;
    if(!val){S.ss=null;}
    if(val&&S.pfosten==='klemme') S.pfosten='abd';
    var sfEl=document.getElementById('zk-ssf-step');
    if(sfEl) sfEl.style.display=val?'':'none';
    render();
  },
  pickSS: function(handle){
    var prod=ZK.ss.find(function(s){return s&&s.handle===handle;});
    if(!prod) return;
    var v=prod.variants.find(function(v){return v.available;})||prod.variants[0];
    S.ss={handle:handle,title:prod.title,vid:v?v.id:null,price:v?v.price:0,colorVal:v?v.o1:''};
    render();
  },
  pickSSFarbe: function(colorVal,vid,price){
    if(S.ss){S.ss.vid=vid;S.ss.colorVal=colorVal;S.ss.price=price;}
    render();
  },
  pickPfosten: function(val){S.pfosten=val;render();},
  changeEck: function(delta){S.eckpfosten=Math.max(0,Math.min(8,S.eckpfosten+delta));render();},
  setTorTyp: function(val){S.torTyp=val;S.torModel=null;render();},
  setTorModel: function(handle){S.torModel=(S.torModel===handle?null:handle);render();},
  pickMontage: function(val){
    S.montage=val;
    var hint=document.getElementById('zkv2-delivery-hint');
    if(hint){
      if(val==='profi'){hint.textContent='🕐 Lieferzeit: 3–8 Wochen';}
      else{hint.textContent='🕐 Lieferzeit: 7–21 Werktage';}
    }
    render();
  },
  setTor: function(vid,delta){
    S.torItems[vid]=(S.torItems[vid]||0)+delta;
    if(S.torItems[vid]<0) S.torItems[vid]=0;
    var el=document.getElementById('torqty-'+vid);
    if(el) el.textContent=S.torItems[vid];
    updateSummary();
  },
  pickAbholort: function(val,km){S.abholort=val;S.abholortKm=(km!=null&&km!=='')?km:null;},
  addToCart: function(){
    if(!S.model||!S.farbe||!S.hoehe||!S.laenge){alert('Bitte Modell, Farbe, Höhe und Länge auswählen.');return;}
    if(!S.abholort){
      alert('Bitte wählen Sie zuerst einen Abholstandort aus (per PLZ-Suche oder Dropdown oben).');
      var _pb=document.getElementById('zkv2-plz-box');
      if(_pb) _pb.scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }

    var _panels=Math.ceil(S.laenge/2.5);
    var _torCount=0;
    Object.keys(S.torItems).forEach(function(k){_torCount+=S.torItems[k]||0;});
    var _regPf=Math.max(0,_panels+1-_torCount);
    var _fpQty=_regPf+S.eckpfosten;

    // Beschreibende Properties nur an der Matte-Position
    var _bndId='bndl_'+Date.now()+'_'+Math.random().toString(36).substr(2,5);
    var _matteProps={
      '_konfigurator':'doppelstab',
      '_abholung':'true',
      '_bundle_id':_bndId,
      '_bundle_source':'abholung',
      'Konfiguration':S.model+' · '+S.hoehe+' · '+S.farbe,
      'Länge':S.laenge+',0 m ('+_panels+' Panels, '+(_regPf+S.eckpfosten)+' Pfosten)',
      'Befestigung':S.befestigung==='einbetonieren'?'Einbetonieren':'Dübelmontage'
    };
    if(S.abholort) _matteProps['Abholort']=S.abholort;
    if(S.abholortKm!=null) _matteProps['Entfernung']='ca. '+S.abholortKm+' km Luftlinie';
    _matteProps['Abholung']='3% Abholrabatt';

    var _kp={'_konfigurator':'doppelstab','_bundle_id':_bndId,'_bundle_source':'abholung'};

    var items=[];

    // 1. Matte
    var _mv=findVar(ZK.matte.variants,[S.model,S.farbe,S.hoehe],true)||findVar(ZK.matte.variants,[S.model,S.farbe,S.hoehe]);
    if(!_mv){alert('Matte nicht gefunden – bitte Konfiguration prüfen.');return;}
    items.push({id:_mv.id,quantity:_panels,properties:_matteProps});

    // 2. Pfosten
    if(S.pfosten&&_regPf>0){
      var _pfProd=S.pfosten==='klemme'?ZK.klemme:ZK.abd;
      var _hM=(parseFloat(S.hoehe)/1000).toFixed(2).replace('.',',');
      var _pfv=findVar(_pfProd.variants,[_hM,farbK(S.farbe)],true)||findVar(_pfProd.variants,[S.hoehe,farbK(S.farbe)],true)||findVar(_pfProd.variants,[_hM,farbK(S.farbe)])||findVar(_pfProd.variants,[S.hoehe,farbK(S.farbe)]);
      if(_pfv){
        var _hoeheM=parseFloat(S.hoehe)/1000;
        var _zugabe=(_hoeheM<=1.23)?0.50:0.60;
        var _gesamtM=_hoeheM+_zugabe;
        var _hoeheStr=_hoeheM.toFixed(2).replace('.',',');
        var _gesamtStr=_gesamtM.toFixed(2).replace('.',',');
        var _pfProps=Object.assign({},_kp,{
          'Hinweis':'Gesamtlänge '+_gesamtStr+' m – für '+_hoeheStr+' m Zaunhöhe (Überlänge zum Einbetonieren oder Kürzen bei Fußplatte)'
        });
        items.push({id:_pfv.id,quantity:_regPf,properties:_pfProps});
      }
    }

    // 3. Eckpfosten
    if(S.eckpfosten>0&&S.pfosten){
      var _eckProd=S.pfosten==='klemme'?ZK.eck_k:ZK.eck_a;
      var _hM2=(parseFloat(S.hoehe)/1000).toFixed(2).replace('.',',');
      var _eckv=findVar(_eckProd.variants,[_hM2,farbK(S.farbe)],true)||findVar(_eckProd.variants,[S.hoehe,farbK(S.farbe)],true)||findVar(_eckProd.variants,[_hM2,farbK(S.farbe)])||findVar(_eckProd.variants,[S.hoehe,farbK(S.farbe)]);
      if(_eckv) items.push({id:_eckv.id,quantity:S.eckpfosten,properties:_kp});
    }

    // 4. Fußplatten (nur Dübelmontage)
    if(S.befestigung==='duebel'&&S.fussplatte&&S.fussplatte.id&&_fpQty>0){
      items.push({id:S.fussplatte.id,quantity:_fpQty,properties:_kp});
    }

    // 5. Sichtschutz
    if(S.sichtschutz&&S.ss&&S.ss.vid){
      var _ssC=calcSSQty();
      if(_ssC.qty>0) items.push({id:S.ss.vid,quantity:_ssC.qty,properties:_kp});
    }

    // 6. Tore
    Object.keys(S.torItems).forEach(function(vid){
      var qty=S.torItems[vid]||0;
      if(qty>0) items.push({id:parseInt(vid),quantity:qty,properties:_kp});
    });

    // 7. Montage entfernt (Abholkonfigurator)
    var _montageHinweis=false;

    var btn=document.getElementById('zkv2-cart-btn');
    var orig=btn?btn.innerHTML:'';
    if(btn){btn.disabled=true;btn.textContent='Prüfe Warenkorb...';}

    function _doAdd(){
      if(btn) btn.textContent='Wird hinzugefügt...';
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({items:items})
      }).then(function(r){
        if(!r.ok) return r.json().then(function(e){throw new Error(e.description||e.message||'Fehler');});
        return r.json();
      }).then(function(){
        // Abholung als WARENKORB-Attribut setzen. Das ist das zuverlässigste Signal
        // für die Checkout-Functions (Cart.attribute erreicht Functions immer –
        // anders als versteckte _-Properties). Damit: Barzahlung aus + nur die
        // 0-€-Abholmethode bleibt im Versand übrig. Erscheint zudem als Hinweis
        // in der Bestellung ("Abholung am Standort").
        return fetch('/cart/update.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({attributes:{'Abholung':'ja','Bestellart':'Abholung am Standort'}})
        }).catch(function(){}); // UI nicht blockieren, falls das Setzen scheitert
      }).then(function(){
        // Button bleibt deaktiviert bis zur nächsten Konfigurationsänderung
        if(btn){btn.dataset.added='1';btn.disabled=true;btn.textContent='✓ Im Warenkorb';}
        var old=document.getElementById('zk-cart-success');
        if(old) old.remove();
        var ov=document.createElement('div');
        ov.id='zk-cart-success';
        ov.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem';
        var box=document.createElement('div');
        box.style.cssText='background:#fff;border-radius:16px;padding:2rem 2.5rem;max-width:440px;width:100%;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.3)';
        if(_montageHinweis){
          box.innerHTML='<div style="font-size:2.5rem;margin-bottom:.75rem">📦</div>'
            +'<div style="font-size:1.1rem;font-weight:700;color:#073f5a;margin-bottom:.5rem">Material wurde hinzugefügt</div>'
            +'<div style="background:#fff8e1;border:1px solid #ffe082;border-radius:8px;padding:.875rem 1rem;font-size:.88rem;color:#5a4000;margin-bottom:1.25rem;text-align:left">'
            +'<strong>Montage: Individuelles Angebot</strong><br>'
            +'Bei diesem Umfang erstellen wir dir ein persönliches Montage-Angebot.<br>'
            +'Melde dich kurz bei uns:<br>'
            +'📞 04952-8299973 &nbsp;·&nbsp; 📧 info@zaunonkel.de'
            +'</div>'
            +'<div style="display:flex;gap:.75rem;justify-content:center;flex-wrap:wrap">'
            +'<button id="zk-cs-close" style="background:#f0f6fb;border:1px solid #d4e8f5;color:#073f5a;padding:.65rem 1.25rem;border-radius:8px;font-weight:600;cursor:pointer;font-size:.9rem">Weiter konfigurieren</button>'
            +'<a href="/cart" style="background:#23a1d1;color:#fff;padding:.65rem 1.25rem;border-radius:8px;font-weight:600;font-size:.9rem;text-decoration:none;display:inline-flex;align-items:center;gap:.35rem">Zum Warenkorb →</a>'
            +'</div>';
        } else {
          box.innerHTML='<div style="font-size:2.5rem;margin-bottom:.75rem">🛒</div>'
            +'<div style="font-size:1.2rem;font-weight:700;color:#073f5a;margin-bottom:.5rem">Erfolgreich hinzugefügt!</div>'
            +'<div style="color:#5a7a8a;font-size:.9rem;margin-bottom:1.5rem">Deine Konfiguration wurde in den Warenkorb gelegt.</div>'
            +'<div style="display:flex;gap:.75rem;justify-content:center;flex-wrap:wrap">'
            +'<button id="zk-cs-close" style="background:#f0f6fb;border:1px solid #d4e8f5;color:#073f5a;padding:.65rem 1.25rem;border-radius:8px;font-weight:600;cursor:pointer;font-size:.9rem">Weiter konfigurieren</button>'
            +'<a href="/cart" style="background:#23a1d1;color:#fff;padding:.65rem 1.25rem;border-radius:8px;font-weight:600;font-size:.9rem;text-decoration:none;display:inline-flex;align-items:center;gap:.35rem">Zum Warenkorb →</a>'
            +'</div>';
        }
        ov.appendChild(box);
        document.body.appendChild(ov);
        ov.addEventListener('click',function(e){if(e.target===ov) ov.remove();});
        document.getElementById('zk-cs-close').addEventListener('click',function(){ov.remove();});
      }).catch(function(err){
        alert('Fehler beim Hinzufügen: '+err.message);
        if(btn){btn.disabled=false;btn.innerHTML=orig;}
      });
    }

    // Guard: Prüfe ob bereits eine Konfigurator-Position im Warenkorb liegt
    fetch('/cart.js')
      .then(function(r){return r.json();})
      .then(function(cart){
        var vorhandene=cart.items.filter(function(item){
          return item.properties&&item.properties['_konfigurator']==='doppelstab';
        });
        if(vorhandene.length>0){
          // WARNEN-Modus: Dialog, Kunde entscheidet
          var ersetzen=confirm(
            'Du hast bereits eine Zaun-Konfiguration im Warenkorb.\n\n'+
            'OK  = Alte Konfiguration ersetzen\n'+
            'Abbrechen = Beide behalten (zweiter Zaun wird hinzugefügt)'
          );
          if(ersetzen){
            var updates={};
            vorhandene.forEach(function(item){updates[item.key]=0;});
            fetch('/cart/update.js',{
              method:'POST',
              headers:{'Content-Type':'application/json'},
              body:JSON.stringify({updates:updates})
            }).then(function(r){return r.json();}).then(function(){_doAdd();});
          } else {
            _doAdd();
          }
        } else {
          _doAdd();
        }
      })
      .catch(function(){_doAdd();});
  }
};

/* ── Init: günstigste Kombination vorauswählen ── */
S.sichtschutz=false;
S.laenge=10;
S.befestigung='einbetonieren';
S.abholort='';
S.pfosten='klemme';
(function(){
  var _vh=[],_vv=[];
  ZK.einzeltore.concat(ZK.doppeltore).filter(Boolean).forEach(function(t){
    if(t.handle) _vh.push(t.handle);
    t.variants.forEach(function(v){if(v.id) _vv.push(String(v.id));});
  });
  if(S.torModel&&_vh.indexOf(S.torModel)<0) S.torModel=null;
  Object.keys(S.torItems).forEach(function(vid){if(_vv.indexOf(vid)<0) delete S.torItems[vid];});
})();
if(ZK.matte.variants.length>0){
  var _cheap=ZK.matte.variants.reduce(function(m,v){return v.price<m.price?v:m;},ZK.matte.variants[0]);
  S.model=_cheap.o1;
  S.farbe=_cheap.o2;
  S.hoehe=_cheap.o3;
}
render();


})();


/* ── PLZ-Standortsuche (Abholkonfigurator) ──
   Findet den nächsten der 10 bestehenden Abholstandorte zur eingegebenen PLZ
   und übernimmt ihn ins Dropdown #zkv2-abholort + in den State (ZKW.pickAbholort). */
(function(){
'use strict';

/* Standorte: Namen EXAKT wie die <option>-Values im Dropdown #zkv2-abholort.
   Koordinaten sind die der echten Abholadressen (straßengenau geocodet) und
   dienen NUR der internen Entfernungsberechnung – die Adressen werden dem
   Kunden NICHT angezeigt (nur Region-Name + ca. km Luftlinie). */
var ZN_STANDORTE = [
  { name:'Raum Oldenburg / Ostfriesland',      lat:53.1087208, lng:7.6697948  },
  { name:'Raum Bremen',                        lat:52.9542891, lng:9.2436599  },
  { name:'Raum Kiel / Neumünster',             lat:54.0482711, lng:10.2244452 },
  { name:'Raum Berlin / Potsdam',              lat:52.4035136, lng:12.9108031 },
  { name:'Raum Dortmund / Sauerland',          lat:51.4681288, lng:7.8425741  },
  { name:'Raum Bochum / Witten',               lat:51.3558045, lng:7.3744204  },
  { name:'Raum Köln / Bonn',                   lat:50.7617542, lng:6.9938892  },
  { name:'Raum Siegen / Südsauerland',         lat:51.0246085, lng:7.8269911  },
  { name:'Region Mittelhessen / Westerwald',   lat:50.4017657, lng:8.0455968  },
  { name:'Raum München',                       lat:48.1210000, lng:11.7087277 }
];

var _znLast = [];   // letzte Top-3-Ergebnisse (für Klick-Auswahl per Index)

function znDistanz(lat1,lng1,lat2,lng2){
  var R=6371;
  var dLat=(lat2-lat1)*Math.PI/180, dLng=(lng2-lng1)*Math.PI/180;
  var a=Math.sin(dLat/2)*Math.sin(dLat/2)
       +Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLng/2)*Math.sin(dLng/2);
  return R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
}
function znEsc(s){return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

/* PLZ → Koordinaten via OpenStreetMap Nominatim (kostenlos, kein Key) */
function znGetKoords(plz){
  var url='https://nominatim.openstreetmap.org/search?postalcode='+encodeURIComponent(plz)+'&country=DE&format=json&limit=1';
  return fetch(url,{headers:{'Accept-Language':'de'}})
    .then(function(r){return r.ok?r.json():null;})
    .then(function(d){
      if(!d||!d.length) return null;
      return {lat:parseFloat(d[0].lat),lng:parseFloat(d[0].lon)};
    })
    .catch(function(){return null;});
}

window.znFindStandort=function(){
  var input=document.getElementById('zkv2-plz-input');
  var erg=document.getElementById('zkv2-plz-ergebnis');
  var btn=document.getElementById('zkv2-plz-btn');
  if(!input||!erg) return;
  var plz=input.value.trim();
  if(!/^\d{5}$/.test(plz)){
    erg.style.display='block';
    erg.innerHTML='<p class="zkv2-plz-error">Bitte eine gültige 5-stellige Postleitzahl eingeben.</p>';
    return;
  }
  if(btn){btn.disabled=true;btn.textContent='⏳ Suche…';}
  erg.style.display='block';
  erg.innerHTML='<p class="zkv2-plz-loading">Standorte werden gesucht…</p>';

  znGetKoords(plz).then(function(koords){
    if(btn){btn.disabled=false;btn.textContent='Standorte anzeigen';}
    if(!koords){
      erg.innerHTML='<p class="zkv2-plz-error">PLZ nicht gefunden. Bitte prüfen Sie die Eingabe.</p>';
      return;
    }
    _znLast=ZN_STANDORTE.map(function(s){
      return {name:s.name,km:znDistanz(koords.lat,koords.lng,s.lat,s.lng)};
    }).sort(function(a,b){return a.km-b.km;}).slice(0,3);

    var html='<div class="zkv2-plz-titel">Die 3 nächsten Abholstandorte für PLZ '+znEsc(plz)+':</div>'
            +'<div class="zkv2-plz-liste">';
    _znLast.forEach(function(s,i){
      var km=s.km.toFixed(0);
      var best=i===0;
      html+='<div class="zkv2-plz-card'+(best?' zkv2-plz-card--best':'')+'" id="zkv2-plz-card-'+i+'" onclick="znWaehleStandort('+i+')">'
        +'<div class="zkv2-plz-card-head"><strong>'+znEsc(s.name)
        +(best?'<span class="zkv2-plz-naechster">Nächster</span>':'')+'</strong>'
        +'<span class="zkv2-plz-km">ca. '+km+' km Luftlinie</span></div>'
        +'<div class="zkv2-plz-waehlen">✓ Diesen Standort wählen</div>'
        +'</div>';
    });
    html+='</div>';
    html+='<div class="zkv2-plz-hinweis">Entfernung als <strong>Luftlinie</strong> (Vogelfluglinie) – die tatsächliche Fahrstrecke ist meist etwas länger.</div>';
    erg.innerHTML=html;
  });
};

window.znWaehleStandort=function(idx){
  var s=_znLast[idx];
  if(!s) return;
  var km=s.km.toFixed(0);

  /* Karten-Markierung */
  var cards=document.querySelectorAll('.zkv2-plz-card');
  for(var i=0;i<cards.length;i++) cards[i].classList.remove('zkv2-plz-card--selected');
  var sel=document.getElementById('zkv2-plz-card-'+idx);
  if(sel) sel.classList.add('zkv2-plz-card--selected');

  /* Dropdown synchronisieren */
  var dd=document.getElementById('zkv2-abholort');
  if(dd) dd.value=s.name;

  /* In den Konfigurator-State übernehmen (schreibt Property 'Abholort' + 'Entfernung') */
  if(window.ZKW&&typeof ZKW.pickAbholort==='function') ZKW.pickAbholort(s.name,km);

  /* Bestätigung */
  var erg=document.getElementById('zkv2-plz-ergebnis');
  if(erg){
    var old=erg.querySelector('.zkv2-plz-confirm');
    if(old) old.remove();
    var c=document.createElement('div');
    c.className='zkv2-plz-confirm';
    c.innerHTML='✅ <strong>'+znEsc(s.name)+'</strong> ausgewählt · ca. '+km+' km Luftlinie';
    erg.appendChild(c);
  }
};
})();


/* Lizenz-Check */
(function() {
  'use strict';
  var _a = ['zaunonkel.de','zaunonkel-gmbh.myshopify.com','zaunonkel-sued.de','zaunonkel-konfigurator.de','localhost','127.0.0.1'];
  var _h = window.location.hostname;
  var _ok = _a.some(function(d){ return _h === d || _h.endsWith('.'+d); });
  if (!_ok) {
    var _s = document.getElementById('zaunkonfig-abholung');
    if (_s) {
      _s.innerHTML = '<div style="padding:60px;text-align:center;font-family:sans-serif;color:#c00"><strong>&#9888; Nicht autorisierte Domain</strong><br><br>Dieser Konfigurator ist lizenziert für zaunonkel.de.</div>';
    }
  }
})();
